export const envDefaults = {
  idleTimeoutMs: 1000 * 60 * 60 * 4,
  idleWarnBufferMs: 1000 * 60 * 10,
  loginUrl: '/ebisui/login',
  legacyAppBaseUrl: '/ebisui/#',
  ebisUIUrl: '/ebisui',
};

export const npdEnvDefaults = {
  ...envDefaults,
  oauth2: {
    clientId: '0oaevympti060P4EV1t7',
    issuer: 'https://mlbtest.okta.com/oauth2/aus9o5h7c8Jze7MrL1t7',
  },
};

// although we only have one prod env for the foreseeable future, it's possible we eventually have multiple
// (e.g. disaster recovery, a/b testing, etc.), so most prod vars should be defined here
export const prodEnvDefaults = {
  ...envDefaults,
  oauth2: {
    clientId: '0oaxp5358yOvuL1cA0x7',
    issuer: 'https://mlb.okta.com/oauth2/ausm1mkeo9YYNpD7V0x7',
  },
};
